import Naluri from '~/common/api/naluri'
import {
  FOOD_JOURNAL_GET_JOURNAL_COMMENTS_BEGIN,
  FOOD_JOURNAL_GET_JOURNAL_COMMENTS_SUCCESS,
  FOOD_JOURNAL_GET_JOURNAL_COMMENTS_FAILURE,
  FOOD_JOURNAL_GET_JOURNAL_COMMENTS_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getJournalComments(id, userID) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: FOOD_JOURNAL_GET_JOURNAL_COMMENTS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const { foodJournal } = getState()
      const page = foodJournal.commentsPagination ? foodJournal.commentsPagination.page + 1 : 1

      const doRequest = Naluri.get(`/api/expert/dishes/${id}/comments?user_id=${userID}&page=${page}&per_page=5`)
      doRequest.then(
        (res) => {
          dispatch({
            type: FOOD_JOURNAL_GET_JOURNAL_COMMENTS_SUCCESS,
            data: {
              comments: res.data,
              pagination: res.pagination
            }
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: FOOD_JOURNAL_GET_JOURNAL_COMMENTS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetJournalCommentsError() {
  return {
    type: FOOD_JOURNAL_GET_JOURNAL_COMMENTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FOOD_JOURNAL_GET_JOURNAL_COMMENTS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getJournalCommentsPending: true,
        getJournalCommentsError: null,
      };

    case FOOD_JOURNAL_GET_JOURNAL_COMMENTS_SUCCESS:
      // The request is success
      return {
        ...state,
        journalComments: state.journalComments.withMutations(journal => {
          action.data.comments.forEach(data => {
            if (journal.id !== data.id) journal.add(data)
          })
        }),
        commentsPagination: action.data.pagination,
        getJournalCommentsPending: false,
        getJournalCommentsError: null,
      };

    case FOOD_JOURNAL_GET_JOURNAL_COMMENTS_FAILURE:
      // The request is failed
      return {
        ...state,
        getJournalCommentsPending: false,
        getJournalCommentsError: action.data.error,
      };

    case FOOD_JOURNAL_GET_JOURNAL_COMMENTS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getJournalCommentsError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/food-journal/redux/getJournalComments.js